export default "__VITE_ASSET__ca2cb15f__"